'use strict';

+function ($) {

  $.fn.passwordToggle = function () {
    return this.each(function () {
      var $input = $(this).find(':password, :text');
      var $toggle = $(this).find('.password-toggle');
      if ($toggle.hasClass('password-visible')) {
        $toggle.removeClass('password-visible');
        $input.attr('type', 'password');
      } else {
        $toggle.addClass('password-visible');
        $input.attr('type', 'text');
      }
    });
  };

  $(document)
  // toggle eye icon input type="text|password" on click
  .on('click.bc.passwordToggle', '.password-toggle', function (e) {
    e.stopPropagation();
    $(e.target).closest('.has-password-toggle').passwordToggle();
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/password-toggle.js
// module id = 11
// module chunks = 0